import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { CommonService } from 'src/app/core/services/common/common.service';
import { StorageService } from 'src/app/core/services/storage/storage.service';
import {
  MENU_UNIQ_NAME,
  routePath,
  USERGROUPS,
} from 'src/app/core/services/utils/constants';
import { DataService } from 'src/app/shared/services/data/data.service';
import * as textConfiguration from 'src/assets/branding/text-branding/static-text-configuration.json';

@Component({
  selector: 'app-top-navbar',

  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.scss',
})
export class TopNavbarComponent implements OnChanges, OnDestroy {
  @Input() menuMode: any = 'standard';
  @Input() isViewInSmaller: boolean = false;

  @Input() sideNav: any;
  staticText: any = (textConfiguration as any).default;
  menuList: any[];
  toggleMenuStatus: boolean[];
  showMenuToggle: boolean = false;
  currentUrl: any;
  position: any;
  showCollapseState: boolean = true;
  isPopupVisible = false;
  commonService: any;
  visibleMenus: any[] = [];
  moreMenus: any[] = [];

  private routeSubscription: Subscription | undefined;

  constructor(
    private route: Router,
    private _common: CommonService,
    private dataService: DataService,
    private _storage: StorageService,
    private authservice: AuthService
  ) {
    this.commonService = this._common.enableMenus$;
    this.menuList = this._common?.sideNavMenu;
    this.toggleMenuStatus = new Array(this.menuList.length).fill(false);
    this.getCurrentUrl();
  }

  ngOnInit(): void {
    this._common.fetchPermssions();
    this.updateMenuDisplay();
    window.addEventListener('resize', this.updateMenuDisplay.bind(this));
    //this.getCurrentUrl();
  }

  ngOnChanges() {
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'someInput'**************/
    //Write your code here
    this.showMenuToggle = this.isViewInSmaller;
  }

  updateMenuDisplay() {
    const totalMenus = this.menuList.filter((menu) => {
      return this.authservice?.hasPermission(menu.permission);
    });

    if (totalMenus.length < 5) {
      this.visibleMenus = totalMenus;
      this.moreMenus = [];
      return;
    }

    const width = window.innerWidth;
    let visibleCount = 0;

    if (width <= 992) {
      visibleCount = totalMenus.length;
    } else if (width <= 1024) {
      visibleCount = 6;
    } else if (width <= 1300) {
      visibleCount = 8;
    } else if (width <= 1440) {
      visibleCount = 9;
    } else if (width <= 1540) {
      visibleCount = 10;
    } else {
      visibleCount = totalMenus.length;
    }

    this.visibleMenus = totalMenus.slice(0, visibleCount);
    this.moreMenus = totalMenus.slice(visibleCount);
  }

  getSubmenuClass(
    isActive: boolean,
    position: number
  ): { [key: string]: boolean } {
    return {
      'active-menu-name': isActive,
      [`submenu-level-${position}`]: true,
    };
  }

  sideNavToggle() {
    this.sideNav?.toggle();
    this.dataService.chartRender.next(true);
  }

  toggleSidenav() {
    this.showCollapseState = !this.showCollapseState;
  }

  setId(menu: any) {
    menu.forEach((menu: any, index: any) => {
      menu.id = index + 1;
      if (menu?.children?.length) {
        this.setId(menu?.children);
      }
    });
  }

  redirect(menu: any) {
    const userDetails: any = this._storage.getUserDetails();

    // First, check if there's a custom function to execute
    if (menu?.action && typeof menu.action === 'function') {
      menu.action(); // Execute the provided function
      return;
    }

    // Then fallback to routing logic
    if (menu?.router) {
      if (
        (menu.uniq_name === MENU_UNIQ_NAME.REGISTRATION_SCP ||
          menu.uniq_name === MENU_UNIQ_NAME.ONBOARD_SCP) &&
        userDetails?.groups?.[0]?.name ===
          USERGROUPS.SUPPLY_CHAIN_PARTICIPANT_ADMINISTRATOR
      ) {
        this.route.navigate([`${routePath?.SCP_APPLICATION_PATH}`]);
      } else {
        this.route.navigate([menu.router]);
      }
    }
  }

  /**
   * @description
   * CATCH RESPECTIVE MENU
   * @param menu List of array
   * @param uniq_name
   * @returns NULL OR RESPECTIVE MENU
   */

  findMenu(menus: any, currentMenu: any, position: any) {
    let collectData: any = {};
    let findMenu: boolean = false;
    menus.forEach((firsrtLevel: any, firsrtLevelIdx: any) => {
      if (findMenu) return;
      collectData.firsrtLevel = firsrtLevel;
      collectData.secoundLevel = null;
      collectData.thirdLevel = null;
      if (firsrtLevel.uniqId == currentMenu.uniqId) {
        findMenu = true;
      }
      firsrtLevel.children.forEach(
        (secoundLevel: any, secoundLevelIdx: any) => {
          if (findMenu) return;
          collectData.secoundLevel = secoundLevel;
          collectData.thirdLevel = null;
          if (secoundLevel.uniqId == currentMenu.uniqId) {
            findMenu = true;
          }
          secoundLevel.children.forEach(
            (thirdLevel: any, thirdLevelIdx: any) => {
              if (findMenu) return;
              collectData.thirdLevel = thirdLevel;
              if (thirdLevel.uniqId == currentMenu.uniqId) {
                findMenu = true;
              }
            }
          );
        }
      );
    });
    return collectData;
  }

  /**
   * @description
   * Menu click funtion...........................
   * @param ev Element Reference
   * @param menu current menu
   * @param index  current index
   */

  private getCurrentUrl(): void {
    this.routeSubscription = this.route.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentUrl = event.url.split('?')[0];
        this.collapseAllMenu(this.menuList);
        this.inactiveAllMenu(this.menuList);
        let menuMap = new Map<string, any>();
        this.buildMenuMap(this.menuList, menuMap);

        const isActivated = this.activateMenuByRouter(
          this.menuList,
          this.currentUrl,
          menuMap
        );

        if (!isActivated) {
          console.warn('No matching route found in menu list.');
        }
      });
  }

  private activateMenuByRouter(
    menuList: any[],
    currentUrl: string,
    menuMap: Map<string, any>
  ): boolean {
    // Find the parent menu based on the parent path
    const parentMenu = this.findParentMenu(menuList, currentUrl);

    if (parentMenu) {
      // Activate the parent menu
      parentMenu.activate = true;
      parentMenu.expand = true;

      // Activate parent menus recursively
      this.activateParentMenus(parentMenu, menuMap);

      return true;
    }

    return false;
  }

  /**
   *  Find the parent menu based on the parent path.
   *  Longest matching route wins so sibling paths like
   *  /portal/beneficiary/list and /portal/beneficiary/list/local-organizations
   *  do not steal each other's highlight.
   */
  private findParentMenu(menuList: any[], parentPath: string): any {
    let bestMenu: any = null;
    let bestScore = -1;

    const visit = (items: any[]) => {
      for (const menu of items) {
        const matchLength = this.getMatchingRouteLength(
          [menu?.router, ...(menu?.dependentRoutes || [])],
          parentPath
        );
        if (matchLength >= 0) {
          const score = matchLength * 10 + (menu?.parentUniqName ? 1 : 0);
          if (score > bestScore) {
            bestScore = score;
            bestMenu = menu;
          }
        }

        if (menu.children && menu.children.length > 0) {
          visit(menu.children);
        }
      }
    };

    visit(menuList);
    return bestMenu;
  }

  /**
   *  Activate parent menus recursively based on parentUniqName.
   */
  private activateParentMenus(menu: any, menuMap: Map<string, any>): void {
    if (!menu.parentUniqName) return;

    // Get the parent menu using parentUniqName (using uniqueId)
    const parentMenu = menuMap.get(menu.parentUniqName);
    if (parentMenu) {
      // Activate parent menu
      parentMenu.activate = true;
      parentMenu.expand = true;

      // Recursively activate the parent of the parent (if parent has parentUniqName)
      this.activateParentMenus(parentMenu, menuMap);
    }
  }

  /**
   *  Matches route or child route (e.g., create, edit, view) and removes `/list` part.
   */
  private isMatchingRoute(
    menuRoutes: string | string[],
    currentUrl: string
  ): boolean {
    return this.getMatchingRouteLength(menuRoutes, currentUrl) >= 0;
  }

  private getMatchingRouteLength(
    menuRoutes: string | string[],
    currentUrl: string
  ): number {
    if (!menuRoutes || !currentUrl) return -1;

    let sanitizedCurrentUrl = currentUrl.trim();

    if (sanitizedCurrentUrl.startsWith('/')) {
      sanitizedCurrentUrl = sanitizedCurrentUrl.slice(1);
    }

    if (sanitizedCurrentUrl.endsWith('/')) {
      sanitizedCurrentUrl = sanitizedCurrentUrl.slice(0, -1);
    }

    const routes = Array.isArray(menuRoutes) ? menuRoutes : [menuRoutes];
    let longestMatch = -1;

    routes.forEach((route) => {
      if (!route) return;

      let sanitizedRoute = route.trim();

      if (sanitizedRoute.startsWith('/')) {
        sanitizedRoute = sanitizedRoute.slice(1);
      }

      if (sanitizedRoute.endsWith('/')) {
        sanitizedRoute = sanitizedRoute.slice(0, -1);
      }

      if (sanitizedRoute.endsWith('/list')) {
        sanitizedRoute = sanitizedRoute.slice(0, -5);
      }

      if (sanitizedRoute.endsWith('/dashboard')) {
        sanitizedRoute = sanitizedRoute.slice(0, -10);
      }

      const isMatch =
        sanitizedRoute === sanitizedCurrentUrl ||
        sanitizedCurrentUrl.startsWith(sanitizedRoute + '/');

      if (isMatch && sanitizedRoute.length > longestMatch) {
        longestMatch = sanitizedRoute.length;
      }
    });

    return longestMatch;
  }

  /**
   *  Recursively builds a menu map for quick lookup.
   */
  private buildMenuMap(menuList: any[], menuMap: Map<string, any>): void {
    menuList.forEach((menu) => {
      if (menu.uniq_name) {
        menuMap.set(menu.uniq_name, menu);
      }

      if (menu.children && menu.children.length > 0) {
        this.buildMenuMap(menu.children, menuMap);
      }
    });
  }

  private inactiveAllMenu(menuList: any[]): void {
    menuList.forEach((menu) => {
      menu.activate = false;
      if (menu.children?.length) {
        this.inactiveAllMenu(menu.children);
      }
    });
  }

  private collapseAllMenu(menuList: any[]): void {
    menuList.forEach((menu) => {
      menu.expand = false;
      if (menu.children?.length) {
        this.collapseAllMenu(menu.children);
      }
    });
  }

  handleMenuClick(event: Event, menu: any, position: number): void {
    this.toggleMenu(menu);
    this.redirect(menu);
  }

  private toggleMenu(menu: any): void {
    menu.expand = !menu.expand;
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
    localStorage.removeItem('activeMenu');
    window.removeEventListener('resize', this.updateMenuDisplay.bind(this));
  }

  togglePopup() {
    this.isPopupVisible = !this.isPopupVisible;
  }
}
